<template>
  <div class="row align-items-start">
    <div
      v-if="!horizontal"
      class="card-group col-lg-4 col-md-6 col-sm-12 pt-3"
      v-for="(post, index) in posts"
      :key="index"
    >
      <div class="card">
        <NuxtLink
          v-if="!post.promotion && post.content_type"
          :to="{
            name: 'language-blog-id-slug',
            params: {
              language: route.params.language,
              id: post.id,
              slug: post.slug,
            },
          }"
        >
          <ContagemRegressivaLive :inicio="post.liveCountdown" :capa="post.cover" largura="290" altura="164">
            <img
              class="cursor-pointer"
              :src="`${post.cover}`"
              :alt="post.title"
              width="290"
              height="164"
            />
          </ContagemRegressivaLive>
        </NuxtLink>
        <a
          v-else-if="!post.promotion && !post.content_type"
          :href="post.link_redirect"
        >
          <ContagemRegressivaLive :inicio="post.liveCountdown" :capa="post.cover" largura="290" altura="164">
            <img
              class="cursor-pointer"
              :src="`${post.cover}`"
              :alt="post.title"
              width="290"
              height="164"
            />
          </ContagemRegressivaLive>
        </a>
        <img
          v-else
          :src="`${post.cover.image}`"
          alt="Banner"
          @click="redirectBanner(post.cover.url)"
          width="290"
          height="164"
        />
        <div class="card-body pt-1" v-if="!post.promotion">
          <NuxtLink
            v-if="post.content_type"
            :to="{
              name: 'language-blog-id-slug',
              params: {
                language: route.params.language,
                id: post.id,
                slug: post.slug,
              },
            }"
          >
            <h5 v-if="horizontal" class="card-title">{{ post.title }}</h5>
            <h5 v-else class="card-title-small">{{ post.title }}</h5>
          </NuxtLink>
          <a v-else :href="post.link_redirect">
            <h5 v-if="horizontal" class="card-title">{{ post.title }}</h5>
            <h5 v-else class="card-title-small">{{ post.title }}</h5>
          </a>

          <p
            class="card-text row c-text"
            v-for="description in post.meta_description"
            :key="description.language_id"
          >
            <span
              v-if="description.language_id === 1 && route.params.language === 'pt-br'"
              v-text="description.content"
            ></span>
            <span
              v-if="description.language_id === 2 && route.params.language === 'en'"
              v-text="description.content"
            ></span>
          </p>

          <div class="row">
            <p class="card-text small col-6" v-if="post.content_type">
              <font-awesome :icon="['far', 'comment-dots']" size="sm" />
              {{ post.comments }}
              {{ translate.commentsBlog }}
            </p>
            <p class="card-text small col-6">
              <font-awesome :icon="['far', 'clock']" size="sm" />
              {{ post.date }}
            </p>
          </div>

          <NuxtLink
            v-if="post.content_type"
            :to="{
              name: 'language-blog-id-slug',
              params: {
                language: route.params.language,
                id: post.id,
                slug: post.slug,
              },
            }"
            class="button--more"
          >
            {{ translate.moreBlog }}
            <font-awesome
              :icon="['fas', 'arrow-right']"
              size="sm"
              style="margin-left: 8px"
            />
          </NuxtLink>
          <a v-else :href="post.link_redirect" class="button--more">
            {{ translate.moreBlog }}
            <font-awesome
              :icon="['fas', 'arrow-right']"
              size="sm"
              style="margin-left: 8px"
            />
          </a>
        </div>
      </div>
    </div>
    <div v-else class="card-group col-lg-12 col-sm-12 mb-4">
      <div class="card">
        <div class="row">
          <div class="col-lg-7">
            <NuxtLink
              v-if="posts.content_type"
              :to="{
                name: 'language-blog-id-slug',
                params: {
                  language: route.params.language,
                  id: posts.id,
                  slug: posts.slug,
                },
              }"
            >
              <ContagemRegressivaLive
                class="horizontal"
                :inicio="posts.liveCountdown"
                :capa="posts.cover"
                largura="537"
                altura="303"
              >
                <img
                  class="horizontal cursor-pointer"
                  :src="`${posts.cover}`"
                  :alt="posts.title"
                  width="537"
                  height="303"
                />
              </ContagemRegressivaLive>
            </NuxtLink>
            <a v-else :href="posts.link_redirect">
              <ContagemRegressivaLive
                class="horizontal"
                :inicio="posts.liveCountdown"
                :capa="posts.cover"
                largura="537"
                altura="303"
              >
                <img
                  class="horizontal cursor-pointer"
                  :src="`${posts.cover}`"
                  :alt="posts.title"
                  width="537"
                  height="303"
                />
              </ContagemRegressivaLive>
            </a>
          </div>
          <div class="card-body ps-4 col-lg-5" v-if="!posts.promotion">
            <NuxtLink
              v-if="posts.content_type"
              :to="{
                name: 'language-blog-id-slug',
                params: {
                  language: route.params.language,
                  id: posts.id,
                  slug: posts.slug,
                },
              }"
            >
              <h5 class="card-title">{{ posts.title }}</h5>
            </NuxtLink>
            <a v-else :href="posts.link_redirect">
              <h5 class="card-title">{{ posts.title }}</h5>
            </a>
            <p
              class="card-text row"
              v-for="description in posts.meta_description"
              :key="description.language_id"
            >
              <span
                v-if="description.language_id === 1 && route.params.language === 'pt-br'"
                v-text="description.content"
              ></span>
              <span
                v-if="description.language_id === 2 && route.params.language === 'en'"
                v-text="description.content"
              ></span>
            </p>

            <div class="row">
              <p class="card-text small col-6" v-if="posts.content_type">
                <font-awesome :icon="['far', 'comment-dots']" size="sm" />
                {{ posts.comments }} {{ translate.commentsBlog }}
              </p>
              <p class="card-text small col-6">
                <font-awesome :icon="['far', 'clock']" size="sm" />
                {{ posts.date }}
              </p>
            </div>

            <NuxtLink
              v-if="posts.content_type"
              :to="{
                name: 'language-blog-id-slug',
                params: {
                  language: route.params.language,
                  id: posts.id,
                  slug: posts.slug,
                },
              }"
              class="button--more"
            >
              {{ translate.moreBlog }}
              <font-awesome
                :icon="['fas', 'arrow-right']"
                size="sm"
                style="margin-left: 8px"
              />
            </NuxtLink>
            <a v-else :href="posts.link_redirect" class="button--more">
              {{ translate.moreBlog }}
              <font-awesome
                :icon="['fas', 'arrow-right']"
                size="sm"
                style="margin-left: 8px"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/menu";
import ContagemRegressivaLive from "@/components/Blog/ContagemRegressivaLive.vue";

defineProps(["posts", "horizontal"]);
const route = useRoute();
const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);

function redirectBanner(url: string) {
  window.location.href = url;
}
</script>
<style scoped>
.card-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 38px;
}

.card-title-small {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
}

.card-text span {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  display: block;
}

.small {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  margin-bottom: 0px;
}

.button--more svg {
  color: #b20000;
}

.button--more {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: right;
}

.small svg {
  margin-right: 5px;
}

.card img {
  width: 290px;
  height: 164px;
  object-fit: cover;
}

/* Contagem regressiva da live no lugar da capa: mesma caixa da imagem. No destaque
   horizontal, a classe .horizontal vale para as duas. */
.card .contagem-live {
  width: 290px;
  height: 164px;
}

.horizontal {
  width: 537px !important;
  height: 303px !important;
}

.banner-promotion img {
  width: 391px;
  height: 222px;
  cursor: pointer;
  object-fit: cover;
}

.card-body {
  background-color: #fff;
  padding: 0px;
}

.category-title {
  background-color: black;
  border-radius: 20px;
  text-align: center;
  max-width: 9rem;
  color: #fff;
  font-size: small;
}
.c-text {
  margin-bottom: 5px;
}

/* regras mobile 769vp */
@media screen and (max-width: 992px) {
  .horizontal {
    width: 100% !important;
    height: unset !important;
  }
  .card img {
    width: 100%;
    height: unset;
    object-fit: cover;
  }
  .card .contagem-live {
    width: 100%;
    height: unset;
  }

  .card-title {
    color: #b20000;
    font-family: "Roboto-Medium";
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 27px;
    margin-top: 10px;
  }

  .card-body {
    padding-left: 10px !important;
  }
}
</style>
